import React, { useState, useEffect } from "react";
import {
  Modal,
  Steps,
  Button,
  Table,
  Slider,
  Row,
  Col,
  message,
  Radio,
} from "antd";
import { PlusCircleOutlined, MinusCircleOutlined } from "@ant-design/icons";
import styles from "./CriterionRandomQuestionModal.module.scss";
import random_exam from "assets/icons/random_exam.png";
import TitleAndBreadCrumb from "components/TitleAndBreadCrumb/TitleAndBreadCrumb";
import { getSubjectService, GetLessonService } from "api/master";
import { validateAndEnterExam } from "services/exam/action/actionEnterTesting";
import IconAlert from "assets/icons/icon-alert.svg";
// import { getCoverExamUrl } from 'util/helper'
import useAuth from "context/auth";
import { TranslateLanguage } from "util/Translate";
import { vocabCriterionRandomQuestionModal } from "util/Translate.variable";
import useWindowSize from "hook/useWindowSize";
import _ from "lodash";

const ALLOWED_KEYS = ["ArrowLeft", "ArrowRight"];
const { Step } = Steps;

const translate = new TranslateLanguage();
translate.addMaping(vocabCriterionRandomQuestionModal);

const CriterionRandomQuestionModal = ({
  visible,
  onClose,
  startAtStep = 1,
  stepOrder = [],
  grades,
  subjects = [],
  onClickGrade,
  activeTabGrade,
  examTypeDetail,
  defaultStep = 0,
  hideStepLesson = false,
  defaultSubject = null,
  defaultSelectLesson = null,
  defaultLessonList = [],
  defaultPublisher = "",
  history,
  onNextStep,
  onPreviousStep,
  publisherList,
  lessonListing,
  subjectCriterion = [],
  level,
}) => {
  const {
    state: { user },
  } = useAuth();
  const [step, setStep] = useState(0);
  //Grade
  const [selectedGrade, setSelectedGrade] = useState();
  const [buttonGradeLoading, setButtonGradeLoading] = useState(false);
  //Subject
  const [subjectList, setSubjectList] = useState([]);
  const [selectedSubject, setSelectSubject] = useState(defaultSubject);
  const [buttonSubjectLoading, setButtonSubjectLoading] = useState(false);
  //Lesson
  const [selectedRowKeysLesson, setSelectedRowKeysLesson] = useState([]);
  const [textSelectRow, setTextSelectRow] = useState(
    translate.convert("เลือกทั้งหมด")
  );
  const [lessonList, setLessonList] = useState(lessonListing);
  //ChooseNumOfExam
  const [numOfExam, setNumOfExam] = useState(20);
  const [isGradeSubscribed, setIsGradeSubscribed] = useState(false);
  const [listPublisherCanAcc, setListPublisherCanAcc] = useState([]);
  if (window?.ResizeObserver) {
    window.ResizeObserver = undefined;
  }
  //Publisher
  const [buttonPublisherLoading, setButtonPublisherLoading] = useState(false);
  const [selectedRowKeysPublisher, setSelectedRowKeysPublisher] = useState([
    defaultPublisher,
  ]);
  const [publisher, setPublisher] = useState(publisherList);
  const [selectPublisher, setSelectPublisher] = useState(defaultPublisher);
  const [textPubSelectRow, setTextPubSelectRow] = useState(
    translate.convert("เลือกทั้งหมด")
  );
  const { width } = useWindowSize();

  useEffect(() => {
    if (startAtStep === 2) {
      getSubjectService({ grade: activeTabGrade }).then((response) => {
        if (response.error) {
          return message.error(
            translate.convert(
              "เกิดข้อผิดพลาดในการดึงข้อมูลวิชา ลองใหม่อีกครั้ง"
            )
          );
        }
        setSubjectList(response);
      });
    }

    if (defaultLessonList.length > 0) {
      setTextSelectRow(translate.convert("เลือกทั้งหมด"));
      setTextPubSelectRow(translate.convert("เลือกทั้งหมด"));
      setLessonList(defaultLessonList);
    }
    if (defaultSubject) {
      setSelectSubject(defaultSubject);
    }
    if (!visible && selectedGrade) {
      setSelectedGrade(selectedGrade);
    }
  }, [defaultLessonList, selectedGrade, startAtStep]);

  useEffect(() => {
    validationSubscription();
  }, []);

  const validationSubscription = () => {
    const userSubscription = user?.mySubscription;

    if (userSubscription.some((item) => item.packageType === "main")) {
      if (userSubscription.some((item) => item.level === "all")) {
        setIsGradeSubscribed(true);
        setListPublisherCanAcc(userSubscription[0].listPublisherCanAccess);
      } else {
        if (!defaultPublisher) {
          setIsGradeSubscribed(true);
          setListPublisherCanAcc(
            userSubscription.find((sub) => sub.level === level)
              ?.listPublisherCanAccess
          );
        } else {
          if (
            userSubscription
              .find((sub) => sub.level === level)
              ?.listPublisherCanAccess.includes(defaultPublisher)
          ) {
            setIsGradeSubscribed(true);
            setListPublisherCanAcc([defaultPublisher]);
          }
        }
      }
    } else if (userSubscription.some((item) => item.packageType === "addOn")) {
      setIsGradeSubscribed(true);
      setListPublisherCanAcc(
        userSubscription.map((sub) => sub.listPublisherCanAccess).flat()
      );
    }
  };

  const customDot = (dot, { index }) => (
    <span
      onClick={() => {
        if (index < step && (!defaultStep || defaultStep === 0)) setStep(index);
      }}
      style={
        index < step && (!defaultStep || defaultStep === 0)
          ? { cursor: "pointer" }
          : {}
      }
    >
      {dot}
    </span>
  );

  const PublisherStep = () => {
    if (window?.ResizeObserver) {
      window.ResizeObserver = undefined;
    }

    const columnsLesson = [
      {
        key: "id",
        dataIndex: "name",
        render: (name, record) => {
          if (record.isSubscribed === "true") {
            return (
              <div className={styles.publisher_list}>
                <img alt="lessonLogo" src={record.logo} />
                <span>{name}</span>
              </div>
            );
          } else {
            return (
              <div className={styles.publisher_list_notSub}>
                <div className={styles.left}>
                  <img alt="lessonLogo" src={record.logo} />
                  <span>{name}</span>
                </div>
                <div className={styles.right}>
                  <div className={styles.cost}>฿{record.price}</div>
                </div>
              </div>
            );
          }
        },
      },
    ];

    const onSelectChangeLesson = (selectedRowKeys) => {
      if (selectedRowKeys === "all") {
        if (selectedRowKeysPublisher.length < listPublisherCanAcc?.length) {
          setTextPubSelectRow(translate.convert("ยกเลิก"));
          return setSelectedRowKeysPublisher(listPublisherCanAcc);
        } else {
          setTextPubSelectRow(translate.convert("เลือกทั้งหมด"));
          return setSelectedRowKeysPublisher([]);
        }
      } else {
        setTextPubSelectRow(translate.convert("เลือกทั้งหมด"));
      }
      if (selectedRowKeys.every((sub) => listPublisherCanAcc.includes(sub))) {
        return setSelectedRowKeysPublisher(selectedRowKeys);
      }
    };

    const rowSelection = {
      selectedRowKeys: selectedRowKeysPublisher,
      onChange: onSelectChangeLesson,
    };

    return (
      <div className={styles.publisher_step}>
        <TitleAndBreadCrumb
          title={{ text: translate.convert("สำนักพิมพ์") }}
          option={{
            options: {
              more: {
                onClick: () => onSelectChangeLesson("all"),
                text: textPubSelectRow,
              },
            },
          }}
        />
        <div className={styles.publisher_container}>
          <Table
            rowKey={(data) => data.id}
            pagination={false}
            rowSelection={rowSelection}
            showHeader={false}
            dataSource={publisher}
            columns={columnsLesson}
          />
        </div>
        <div className={styles.footer_button} id="selectall">
          {startAtStep < 3 && (
            <Button
              className={styles.btnUndo}
              onClick={() => {
                setTextPubSelectRow(translate.convert("เลือกทั้งหมด"));
                onPreviousStep(step - 1);
              }}
            >
              ย้อนกลับ
            </Button>
          )}
          <Button
            id="nextThree"
            loading={buttonPublisherLoading}
            onClick={async () => {
              if (_.isEmpty(_.without(selectedRowKeysPublisher, ""))) {
                return message.error(translate.convert("กรุณาเลือกสำนักพิมพ์"));
              } else {
                setButtonPublisherLoading(true);
                await GetLessonService(
                  selectedSubject,
                  activeTabGrade,
                  "",
                  selectedRowKeysPublisher
                ).then((res) => setLessonList(res));
              }
              setStep(step + 1);
              if (onNextStep) {
                onNextStep(step + 1);
              }
              setButtonPublisherLoading(false);
            }}
            type="primary"
          >
            {translate.convert("ถัดไป")}
          </Button>
        </div>
      </div>
    );
  };

  const GradeStep = () => {
    const columnsLesson = [
      {
        key: "grade",
        dataIndex: "fullText",
        title: "ระดับชั้น",
        render: (fullText, record) => (
          <div
            value={record.grade}
            checked={selectedGrade === record.grade}
            onChange={(event) => {
              setSelectedGrade(event.target.value);
            }}
          >
            {fullText}
          </div>
        ),
      },
    ];

    const rowSelection = {
      type: "radio",
      selectedRowKeys: [selectedGrade],
      onChange: (selectedRowKeys, selectedRows) => {
        setSelectedGrade(selectedRowKeys[0]);
      },
    };

    return (
      <div className={styles.lesson_step}>
        <TitleAndBreadCrumb title={{ text: translate.convert("ระดับชั้น") }} />
        <div className={styles.lesson_container}>
          <Table
            rowKey={(data) => data.grade}
            pagination={false}
            rowSelection={rowSelection}
            showHeader={false}
            columns={columnsLesson}
            dataSource={grades}
          />
        </div>
        <div className={styles.footer_button} id="selectall">
          <Button
            id="nextThree"
            type="primary"
            onClick={() => {
              if (!selectedGrade) {
                return message.error(translate.convert("กรุณาเลือกสำนักพิมพ์"));
              }
              setStep(step + 1);
              if (onNextStep) {
                onNextStep(step + 1);
              }
            }}
          >
            {translate.convert("ถัดไป")}
          </Button>
        </div>
      </div>
    );
  };

  const SubjectStep = () => {
    const columnsLesson = [
      {
        key: "id",
        dataIndex: "name",
        title: "วิชา",
        info: "info",
        render: (name, info, record) => (
          <div
            value={record.id}
            checked={selectedSubject === record.id}
            onChange={(event) => {
              setSelectSubject(event.target.value);
            }}
          >
            {`${name}${info.info ? `(${info.info})` : ""}`}
          </div>
        ),
      },
    ];

    const rowSelection = {
      type: "radio",
      selectedRowKeys: [selectedSubject],
      onChange: (selectedRowKeys, selectedRows) => {
        setSelectSubject(selectedRowKeys[0]);
      },
    };

    return (
      <div className={styles.lesson_step}>
        <TitleAndBreadCrumb title={{ text: translate.convert("ระดับชั้น") }} />
        <div className={styles.lesson_container}>
          <Table
            rowKey={(data) => data.id}
            pagination={false}
            rowSelection={rowSelection}
            showHeader={false}
            columns={columnsLesson}
            dataSource={subjects}
          />
        </div>
        <div className={styles.footer_button}>
          <Button
            className={styles.btnUndo}
            onClick={() => {
              setStep(step - 1);
              if (onPreviousStep) {
                onPreviousStep(step - 1);
              }
            }}
          >
            {translate.convert("ย้อนกลับ")}
          </Button>
          <Button
            id="nextTwo"
            loading={buttonSubjectLoading}
            onClick={async () => {
              setButtonSubjectLoading(true);
              let res = [];
              if (res.length === 0) {
                res = await GetLessonService(
                  selectedSubject,
                  selectedGrade,
                  "",
                  selectedRowKeysPublisher
                );
              }
              setLessonList(res);
              setStep(step + 1);
              if (onNextStep) {
                onNextStep(step + 1);
              }
              setButtonSubjectLoading(false);
            }}
            type="primary"
          >
            {translate.convert("ถัดไป")}
          </Button>
        </div>
      </div>
    );
  };

  const LessonStep = () => {
    if (window?.ResizeObserver) {
      window.ResizeObserver = undefined;
    }
    const columnsLesson = [
      {
        key: "id",
        dataIndex: "name",
        render: (name, record) => (
          <div className={styles.lesson_list}>
            <img alt="lessonLogo" src={record.logo} />
            <span>{name}</span>
          </div>
        ),
      },
    ];

    const onSelectChangeLesson = (selectedRowKeys) => {
      if (selectedRowKeys === "all") {
        if (selectedRowKeysLesson.length < lessonList.length) {
          setTextSelectRow(translate.convert("ยกเลิก"));
          let arrId = [];
          arrId = lessonList.map((les) => les.id);
          return setSelectedRowKeysLesson(arrId);
        } else {
          setTextSelectRow(translate.convert("เลือกทั้งหมด"));
          return setSelectedRowKeysLesson([]);
        }
      } else {
        setTextSelectRow(translate.convert("เลือกทั้งหมด"));
      }
      setSelectedRowKeysLesson(selectedRowKeys);
    };
    const rowSelection = {
      selectedRowKeys: selectedRowKeysLesson,
      onChange: onSelectChangeLesson,
    };
    return (
      <div className={styles.lesson_step}>
        <TitleAndBreadCrumb
          title={{ text: translate.convert("บทเรียน") }}
          option={{
            options: {
              more: {
                onClick: () => onSelectChangeLesson("all"),
                text: textSelectRow,
              },
            },
          }}
        />
        <div className={styles.lesson_container}>
          <Table
            rowKey={(data) => data.id}
            pagination={false}
            rowSelection={rowSelection}
            showHeader={false}
            columns={columnsLesson}
            dataSource={lessonList}
            // scroll={{ y: 260 }}
          />
        </div>
        {
          <div className={styles.footer_button} id="selectall">
            {/* {startAtStep < 3 && ( */}
            <Button
              className={styles.btnUndo}
              onClick={() => {
                setTextSelectRow(translate.convert("เลือกทั้งหมด"));
                setStep(step - 1);
                if (onPreviousStep) {
                  onPreviousStep(step - 1);
                }
              }}
            >
              ย้อนกลับ
            </Button>
            {/* )} */}
            <Button
              id="nextThree"
              onClick={() => {
                if (selectedRowKeysLesson.length < 1) {
                  return message.error(translate.convert("กรุณาเลือกบทเรียน"));
                }
                setStep(step + 1);
                if (onNextStep) {
                  onNextStep(step + 1);
                }
              }}
              type="primary"
            >
              {translate.convert("ถัดไป")}
            </Button>
          </div>
        }
      </div>
    );
  };

  const ChooseNumOfExamStep = () => {
    if (window?.ResizeObserver) {
      window.ResizeObserver = undefined;
    }
    const maximum = 50;
    const minimum = 10;
    const lessonLength = selectedRowKeysLesson?.length;
    let minimumExam = lessonLength > minimum ? lessonLength : minimum;
    let defaultNumExam = lessonLength > numOfExam ? lessonLength : numOfExam;
    if (numOfExam < defaultNumExam) {
      setNumOfExam(defaultNumExam);
    }
    useEffect(() => {
      const keyPressHandler = ({ key }) => {
        if (ALLOWED_KEYS.includes(key)) {
          if (key === "ArrowLeft") {
            setNumOfExam(numOfExam > minimumExam ? numOfExam - 1 : minimumExam);
          } else if (key === "ArrowRight") {
            setNumOfExam(numOfExam + 1 < maximum ? numOfExam + 1 : maximum);
          }
        }
      };
      window.addEventListener("keydown", keyPressHandler);
      return () => {
        window.removeEventListener("keydown", keyPressHandler);
      };
    }, []);
    return (
      <div className={styles.choose_num_of_exam_step}>
        <TitleAndBreadCrumb
          title={{ text: translate.convert("จำนวนข้อสอบ") }}
        />
        <div className={styles.scale_top}>
          <MinusCircleOutlined
            onClick={() =>
              setNumOfExam(
                numOfExam > minimumExam ? numOfExam - 1 : minimumExam
              )
            }
            className={styles.icon}
          />
          <span className={styles.num_exam}>{defaultNumExam}</span>
          <PlusCircleOutlined
            onClick={() =>
              setNumOfExam(numOfExam + 1 < maximum ? numOfExam + 1 : maximum)
            }
            className={styles.icon}
          />
        </div>
        <Slider
          min={minimumExam}
          max={maximum}
          defaultValue={defaultNumExam}
          //onChange={(value) => setNumOfExam(value)} //cannot drag & drop to scale score for free
          onAfterChange={(value) => setNumOfExam(value)}
        />
        <div className={styles.scale_bottom}>
          <span className={styles.text}>{minimumExam}</span>
          <span className={styles.text}>{maximum}</span>
        </div>
        <div className={styles.footer_button}>
          {startAtStep < 4 && (
            <Button
              className={styles.btnUndo}
              onClick={() => {
                setStep(step - 1);
                if (onPreviousStep) {
                  onPreviousStep(step - 1);
                }
              }}
            >
              {translate.convert("ย้อนกลับ")}
            </Button>
          )}
          <Button
            id="nextFour"
            onClick={() => {
              setStep(step + 1);
              if (onNextStep) {
                onNextStep(step + 1);
              }
            }}
            type="primary"
          >
            {translate.convert("ถัดไป")}
          </Button>
        </div>
      </div>
    );
  };

  const ExamDetail = (props) => {
    if (window?.ResizeObserver) {
      window.ResizeObserver = undefined;
    }
    const subject = (subjectList.length > 0 ? subjectList : subjects).find(
      (sub) => sub?.id === selectedSubject
    );

    const grade = (
      grades.length <= 2 ? grades.flatMap((g) => g.education) : grades
    ).find((g) => g?.grade === parseInt(selectedGrade));

    let content = [];
    let contentPublisher = [];

    if (defaultSelectLesson) {
      content.push(lessonList.find((less) => less.id === defaultSelectLesson));
    } else {
      selectedRowKeysLesson.map((sl) =>
        content.push(lessonList.find((less) => less.id === sl))
      );
    }

    if (defaultPublisher) {
      contentPublisher.push(defaultPublisher);
    } else {
      selectedRowKeysPublisher.map((item) => contentPublisher.push(item));
    }

    return (
      <div className={styles.exam_detail}>
        <div className={styles.exam_detail_group}>
          <div className={`${styles.logo}`}>
            <img alt="examCover" src={random_exam || IconAlert} />
          </div>
          <div className={styles.title}>
            <h4>{`${subject.name} ${subject.info ? `(${subject.info})` : ""} ${
              grade?.webText || ""
            }`}</h4>
          </div>
          <Row style={{ marginBottom: "10px" }}>
            <Col span={6}>
              <span className={styles.left_text}>
                {translate.convert("จำนวนข้อสอบ")}
              </span>
            </Col>
            <Col span={18}>
              <span>{`${numOfExam} ${translate.convert("ข้อ")}`}</span>
            </Col>
          </Row>
          <Row style={{ marginBottom: "10px" }}>
            <Col span={6}>
              <span className={styles.left_text}>
                {translate.convert("เนื้อหาข้อสอบ")}
              </span>
            </Col>
            <Col span={18} style={{ lineHeight: 2 }}>
              {content.filter((c) => c).length > 0 &&
                content.map((c, i) => <p key={i}>{c?.name}</p>)}
            </Col>
          </Row>
          <Row style={{ marginBottom: "10px" }}>
            <Col span={6}>
              <span className={styles.left_text}>
                {translate.convert("สำนักพิมพ์")}
              </span>
            </Col>
            <Col span={18} style={{ lineHeight: 2 }}>
              {defaultPublisher ? (
                <p>
                  {publisher.find((pub) => pub.id === contentPublisher[0]).name}
                </p>
              ) : (
                publisherList
                  .filter((pubList) => contentPublisher.includes(pubList.id))
                  .map((each) => {
                    return <p>{each.name}</p>;
                  })
              )}
            </Col>
          </Row>
        </div>

        <div className={styles.footer_button}>
          <Button
            className={styles.btnUndo}
            onClick={() => {
              setStep(step - 1);
              if (onPreviousStep) {
                onPreviousStep(step - 1);
              }
            }}
          >
            {translate.convert("ย้อนกลับ")}
          </Button>
          <Button
            id={`${
              isGradeSubscribed &&
              contentPublisher.every((sub) => listPublisherCanAcc.includes(sub))
                ? "enterExam"
                : "buyPackage"
            }`}
            onClick={() => {
              if (
                isGradeSubscribed &&
                contentPublisher.every((sub) =>
                  listPublisherCanAcc.includes(sub)
                )
              ) {
                validateAndEnterExam(user, {
                  isRandom: true,
                  gradeId: parseInt(selectedGrade) || parseInt(activeTabGrade),
                  subjectId: selectedSubject,
                  lessonId:
                    content.map((lesson) => lesson.id) || selectedRowKeysLesson,
                  publisherId: contentPublisher,
                  amoungQuestions: numOfExam,
                  history,
                  level: level,
                });
              } else {
                history.push("/package", {
                  gradeId: selectedGrade || activeTabGrade,
                });
              }
            }}
            type="primary"
          >
            {isGradeSubscribed &&
            contentPublisher.every((sub) => listPublisherCanAcc.includes(sub))
              ? translate.convert("เริ่มทำข้อสอบ")
              : translate.convert("ซื้อแพ็กเกจ")}
          </Button>
        </div>
      </div>
    );
  };

  const onCancle = () => {
    setStep(0);
    setSelectedGrade();
    setSelectSubject(defaultSubject);
    setSelectedRowKeysLesson([]);
    setNumOfExam(20);
    onClose();
  };

  const Content = () => {
    if (window?.ResizeObserver) {
      window.ResizeObserver = undefined;
    }

    const orderedContents = stepOrder.map((step) => {
      switch (step) {
        case 1:
          return <PublisherStep key={step} />;
        case 2:
          return <GradeStep key={step} />;
        case 3:
          return <SubjectStep key={step} />;
        case 4:
          return <LessonStep key={step} />;
        case 5:
          return <ChooseNumOfExamStep key={step} />;
        case 6:
          return <ExamDetail key={step} />;
        default:
          return null;
      }
    });

    if (hideStepLesson) {
      orderedContents.splice(2, 1);
    }

    return orderedContents[step];
  };

  const getStepTitle = (step) => {
    switch (step) {
      case 1:
        return "เลือกสำนักพิมพ์";
      case 2:
        return "เลือกระดับชั้น";
      case 3:
        return "เลือกวิชา";
      case 4:
        return "เลือกบทเรียน";
      case 5:
        return "เลือกจำนวนข้อสอบ";
      case 6:
        return "รายละเอียดข้อสอบ";
      default:
        return "";
    }
  };

  const Title = () => {
    const titles = stepOrder.map((step, index) => (
      <div className={styles.title}>
        <h2 key={index}>{translate.convert(getStepTitle(step))}</h2>
      </div>
    ));

    if (hideStepLesson) {
      titles.splice(2, 1);
    }

    return titles[step];
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancle}
      footer={false}
      maskClosable={false}
      centered
      width={"auto"}
      bodyStyle={{
        padding: "1rem",
        width: `${(width * 3) / 4}px`,
        maxWidth: "650px",
      }}
      destroyOnClose
    >
      <div className={styles.modal_container}>
        <div className={styles.header_text}>
          <Title />
          <Steps
            responsive={false}
            className={styles.headerSteps}
            current={step}
            size="small"
            // progressDot={customDot}
          >
            {stepOrder.map((step, index) => (
              <Step key={index} />
            ))}
          </Steps>
        </div>
        <div className={styles.criterionContent}>
          <Content />
        </div>
      </div>
    </Modal>
  );
};
export default CriterionRandomQuestionModal;
